import React from 'react';
import MaterialFormControlLabel from '@mui/material/FormControlLabel';
import {styled} from '@mui/material/styles';
import type {FormControlLabelProps as MaterialFormControlLabelProps} from '@mui/material/FormControlLabel';

export type FormControlLabelProps = MaterialFormControlLabelProps;

const StyledFormControlLabel = styled(MaterialFormControlLabel)(({theme}) => ({
    '&:not(.Mui-disabled):hover': {
        '& .MuiCheckbox-root': {
            '& .MuiSvgIcon-root': {
                fill: theme.palette.primary.main
            }
        },
        '& .MuiRadio-root': {
            '& .MuiSvgIcon-root': {
                fill: theme.palette.primary.main
            }
        }
    },
    '& .MuiCheckbox-root, & .MuiRadio-root, & .MuiSwitch-root': {
        '& + .MuiFormControlLabel-label': {
            fontSize: theme.typography.button.fontSize,
            lineHeight: '1.125rem'
        }
    },
    marginBottom: '0',
    '&.MuiFormControlLabel-labelPlacementStart': {
        marginLeft: 0
    },
    '&.MuiFormControlLabel-labelPlacementBottom': {
        marginLeft: 0,
        alignItems: 'start',

        '& .MuiSwitch-root': {
            marginLeft: 0,
            marginTop: 0
        }
    },
    '&.MuiFormControlLabel-labelPlacementTop': {
        marginLeft: 0,
        alignItems: 'start',

        '& .MuiSwitch-root': {
            marginLeft: 0,
            marginBottom: 0
        }
    }
}));

export const FormControlLabel = React.forwardRef<any, FormControlLabelProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <StyledFormControlLabel
                ref={ref}
                {...props}
            >
                {children}
            </StyledFormControlLabel>
        );
    });

FormControlLabel.displayName = 'FormControlLabel';
